<div class="container">
  <div class="measurementSystem">
    <span>Measurement System</span>
    <jmkw-radios
      [radioNodeMap]="measurementNodeMap"
      [selectedId]="selectedId('measurementSystem')"
      [name]="formatName('measurementSystem')"
      (nodeChanged)="radioChangeHandler($event)"
    ></jmkw-radios>
  </div>
  @for (radioNode of radioNodeMap() | keyvalue; track radioNode) {
    <div class="radios">
      <span>{{ formatName(radioNode.key) }}</span>
      <jmkw-radios
        [radioNodeMap]="radioNode.value"
        [selectedId]="selectedId(radioNode.key)"
        [name]="formatName(radioNode.key)"
        (nodeChanged)="radioChangeHandler($event)"
      ></jmkw-radios>
    </div>
  }
</div>
